<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
  >
    <path
      d="M17.05 20.28c-.98.95-2.05.88-3.08.4-1.09-.5-2.08-.51-3.21 0-1.45.59-2.23.43-3.06-.4C1.45 14.5 2.35 6.07 8.81 5.69c1.43.07 2.42.71 3.27.79 1.26-.27 2.46-1.04 3.81-.93 1.6.13 2.81.79 3.61 2.05-3.29 1.96-2.54 6.21.42 7.42-.59 1.55-1.36 3.08-2.85 5.26zM12 5.65c-.13-2.32 1.78-4.3 4-4.65.31 2.6-2.33 4.79-4 4.65z"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconApple',
  props: { size: { type: [String, Number], default: 22 } },
};
</script>
